import logo from "@/assets/logo/promptlayer-cake-color.svg";
import { Button } from "@/components/ui/button";
import NavigationTabs from "@/components/ui/TabNavigation";
import { useAuth } from "@/context/auth-context";
import { GoogleReCaptchaProvider } from "@/providers/GoogleReCaptchaProvider";
import { URL_PARAM_KEYS } from "@/utils/utils";
import { OfficeBuildingIcon, UserIcon } from "@heroicons/react/outline";
import {
  OfficeBuildingIcon as OfficeBuildingIconSolid,
  UserIcon as UserIconSolid,
} from "@heroicons/react/solid";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RegularLogin } from "./RegularLogin";
import { SSOLogin } from "./SSOLogin";

const LoginForm = () => {
  const auth = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const inviteToken = searchParams.get(URL_PARAM_KEYS.INVITE) || "";
  sessionStorage.setItem(URL_PARAM_KEYS.INVITE, inviteToken);

  useEffect(() => {
    if (auth?.userToken) navigate("/");
  }, [auth?.userToken, navigate]);

  useEffect(() => {
    if (searchParams.get("sso") === "true") {
      setCurrentTabIndex(1);
    }
  }, [searchParams]);

  const tabs = [
    {
      name: "Login via email",
      content: <RegularLogin />,
      id: 0,
      outlineIcon: <UserIcon />,
      solidIcon: <UserIconSolid />,
    },
    {
      name: "Login via SSO",
      content: <SSOLogin />,
      id: 1,
      outlineIcon: <OfficeBuildingIcon />,
      solidIcon: <OfficeBuildingIconSolid />,
    },
  ];

  const handleTabChange = (index: number) => {
    setCurrentTabIndex(index);
    if (index === 1) {
      setSearchParams({ sso: "true" });
    } else {
      setSearchParams({});
    }
  };

  return (
    <>
      <div className="flex flex-col items-center justify-center gap-2">
        <img src={logo} alt="logo" className="h-[52px] w-[52px]" />
        <span className="text-3xl font-bold text-gray-900">Log In</span>
      </div>
      <NavigationTabs
        className="flex items-center !justify-center"
        handleTabChange={handleTabChange}
        currentTabIndex={currentTabIndex}
        tabs={tabs}
      />
      {currentTabIndex === 0 && (
        <div className="text-center text-sm font-light text-gray-800">
          Don't have an account yet?{" "}
          <Button
            variant="inlineLink"
            onClick={() => navigate("/create-account")}
          >
            Create an account.
          </Button>
        </div>
      )}
    </>
  );
};

const Login = () => {
  return (
    <GoogleReCaptchaProvider>
      <LoginForm />
    </GoogleReCaptchaProvider>
  );
};

export default Login;
